import React, { useContext, useState } from 'react';

import { AlertaContexto } from '.';

export interface Props {
    titulo?: string;
    padrao?: string;
    placeholder?: string;
    botao?: string;
    aoConfirmar: (valor: string) => void;
}

const Pergunta = ({ titulo, padrao, placeholder, botao, aoConfirmar }: Props): React.ReactElement =>
{
    const { setPergunta } = useContext(AlertaContexto);
    const [ valor, setValor ] = useState<string>('');

    const confirmar = async (): Promise<void> =>
    {
        await aoConfirmar(valor);

        setPergunta(null);
    }

    return (
        <React.Fragment>
            <div className="modal show animate__animated animate__fadeIn animate__faster d-block">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        { titulo && (
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    { titulo }
                                </h5>
                            </div>
                        ) }
                        <div className="modal-body">
                            <div className="form-group mb-0">
                                <input
                                    type="text"
                                    name="busca"
                                    className="form-control"
                                    defaultValue={ padrao }
                                    onChange={ evento => setValor(evento.currentTarget.value) }
                                    onKeyDown={ evento => evento.key === 'Enter' ? confirmar() : null }
                                    placeholder={ placeholder }
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-light"
                                onClick={ () => setPergunta(null) }
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ confirmar }
                            >
                                <React.Fragment>
                                    { (botao ? botao : 'Enviar') }
                                </React.Fragment>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </React.Fragment>
    )
}

export default Pergunta;
